import React, { useRef, createRef, useLayoutEffect, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from "react-router-dom";
import { getViewportDimensions } from '../../../../models/Utils';
import NextStory from '../../../Common/NextStory/NextStory';

import './CreditsWrapper.scss';

const CreditsWrapper = ({ next, title, subtitle }) => {
    const creditsElement = useRef(null);
    const fixedMeasurerElement = useRef(null);
    const [creditsActive, setCreditsActive] = useState(false);

    const handleScroll = () => {
      // if (creditsElement && creditsElement.current){
      //   const sliderRect = creditsElement.current.getBoundingClientRect();
      //   const windowHeight = getViewportDimensions().height;
      //   if ((sliderRect.y <= windowHeight)) {
      //     setCreditsActive(true);
      //   }
      //   else if ((sliderRect.y > windowHeight)) {
      //     setCreditsActive(false);
      //   }
      // }
      if (creditsElement && creditsElement.current && fixedMeasurerElement && fixedMeasurerElement.current){
        const rect = creditsElement.current.getBoundingClientRect();
        const measureRect = fixedMeasurerElement.current.getBoundingClientRect();
        if ((rect.y <= measureRect.y + measureRect.height)) {
          setCreditsActive(true);
        }
        else if ((rect.y > measureRect.y + measureRect.height)) {
          setCreditsActive(false);
        }
      }
    };

    useEffect(() => {
      let supportsPassive = false;
      try {
        window.addEventListener(
          'test',
          null,
          Object.defineProperty({}, 'passive', {
            get: function () {
              supportsPassive = true;
            },
          })
        );
      } catch (e) {}
      const wheelOpt = supportsPassive ? { passive: false } : false;
      const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
      
      document.body.addEventListener(wheelEvent, handleScroll, wheelOpt);
      document.body.addEventListener('scroll', handleScroll);
  
      return () => {
        document.body.removeEventListener('scroll', handleScroll);
        document.body.removeEventListener(wheelEvent, handleScroll, wheelOpt);
      };
  
    }, []);

    return (
        <div className="credits-wrapper" ref={creditsElement} aria-hidden={!creditsActive?"true":"false"}>
          <div className="credits-wrapper-measurer" ref={fixedMeasurerElement}></div>
            <NextStory 
                showCredits={creditsActive}
                showNext={creditsActive}
                next={next}
                title={title}
                subtitle={subtitle}
                onCreditsClick={() => {}}
                />
        </div>
    );
};

export default CreditsWrapper;
